import { initializeApp } from "firebase/app";
import { getFirestore, collection, addDoc, query, where, getDocs } from "firebase/firestore";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA9POaFPDmFWLg2WiBtlZXU7sWlgbSG2E4",
  authDomain: "diamond-project-cf37b.firebaseapp.com",
  projectId: "diamond-project-cf37b",
  storageBucket: "diamond-project-cf37b.appspot.com",
  messagingSenderId: "381060633989",
  appId: "1:381060633989:web:98af578db08a986dc8a0ec",
  measurementId: "G-4VJB3Z508T"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);


export{app,auth,createUserWithEmailAndPassword,signInWithEmailAndPassword,collection, addDoc,db,storage}